<template>
    <div class="wecodefy-yt-player-wrapper">
        <!-- EVP holder -->
        <div id="myDivHolder" class="fwd-hide">
            <div id="myDiv"></div>
        </div>

    </div>
</template>
  
<script>

export default {
    name: "yt-player",
    props: {
        url: {
            type: String,
            required: true
        }
    },
    data() {
        return {

        };
    },
    computed: {

    },
    mounted() {
        let vm = this;
        if ($('#myDivHolder').hasClass('fwd-hide-top')) {
            $('#myDivHolder').addClass('reveal-top');
        } else {
            $('#myDivHolder').addClass('reveal');
        }
        setTimeout(function () {
            $('#myDivHolder').css({ 'transform': 'none' });
        }, 2000);

        vm.initiatePlayer();
    },
    beforeDestroy() {
        let vm = this;

    },
    watch: {
        url() {
            let vm = this;
            vm.initiatePlayer();
        }
    },
    methods: {
        initiatePlayer() {
            let vm = this;
            const playerContainer = document.querySelector('.wecodefy-yt-player-wrapper');
            // close FWDEVPlayer instance if exists
            if (window['player1'] != undefined) {
                window['player1'] = null;
            }
            const player = new FWDEVPlayer({
                instanceName: "player1",
                parentId: "myDiv",
                mainFolderPath: "/yt/content",
                initializeOnlyWhenVisible: "no",
                skinPath: "minimal_skin_dark",
                displayType: "responsive",
                fillEntireVideoScreen: "no",
                playsinline: "yes",
                autoScale: "yes",
                openDownloadLinkOnMobile: "no",
                useVectorIcons: "no",
                useResumeOnPlay: "no",
                goFullScreenOnButtonPlay: "no",
                useHEXColorsForSkin: "no",
                normalHEXButtonsColor: "#FF0000",
                privateVideoPassword: "",
                startAtTime: "",
                stopAtTime: "",
                startAtVideoSource: 2,
                videoSource: [
                    { source: vm.url, label: "" }
                ],
                posterPath: "",
                showErrorInfo: "yes",
                fillEntireScreenWithPoster: "yes",
                disableDoubleClickFullscreen: "no",
                addKeyboardSupport: "yes",
                useChromeless: "no",
                showPreloader: "yes",
                preloaderColors: ["#999999", "#FFFFFF"],
                autoPlay: "yes",
                enableAutoplayOnMobile: "no",
                loop: "no",
                scrubAtTimeAtFirstPlay: "00:00:00",
                maxWidth: playerContainer.offsetWidth,
                maxHeight: playerContainer.offsetHeight,
                volume: .8,
                greenScreenTolerance: 200,
                backgroundColor: "#000000",
                posterBackgroundColor: "#000000",
                //lightbox settings
                closeLightBoxWhenPlayComplete: "no",
                lightBoxBackgroundOpacity: .6,
                lightBoxBackgroundColor: "#000000",
                //logo settings
                showLogo: "no",
                hideLogoWithController: "no",
                logoPosition: "topRight",
                logoLink: "",
                logoMargins: 5,
                //controller settings
                showController: "yes",
                showDefaultControllerForVimeo: "no",
                showScrubberWhenControllerIsHidden: "yes",
                showControllerWhenVideoIsStopped: "yes",
                showVolumeScrubber: "yes",
                showVolumeButton: "yes",
                showTime: "no",
                showRewindButton: "yes",
                showQualityButton: "yes",
                showSubtitleButton: "yes",
                showShareButton: "no",
                showDownloadButton: "no",
                showMainScrubberToolTipLabel: "yes",
                showChromecastButton: "no",
                showFullScreenButton: "yes",
                repeatBackground: "yes",
                controllerHeight: 41,
                controllerHideDelay: 3,
                startSpaceBetweenButtons: 7,
                spaceBetweenButtons: 9,
                mainScrubberOffestTop: 14,
                scrubbersOffsetWidth: 4,
                timeOffsetLeftWidth: 5,
                timeOffsetRightWidth: 3,
                volumeScrubberWidth: 80,
                volumeScrubberOffsetRightWidth: 0,
                timeColor: "#777777",
                showYoutubeRelAndInfo: "no",
                youtubeQualityButtonNormalColor: "#777777",
                youtubeQualityButtonSelectedColor: "#FFFFFF",
                scrubbersToolTipLabelBackgroundColor: "#FFFFFF",
                scrubbersToolTipLabelFontColor: "#5a5a5a",
                //redirect at video end
                redirectURL: "",
                redirectTarget: "_blank",
                //cuepoints
                executeCuepointsOnlyOnce: "no",
                cuepoints: [],
                //annotations
                annotiationsListId: "none",
                showAnnotationsPositionTool: "no",
                //subtitles
                showSubtitleButton: "no",
                subtitlesOffLabel: "Subtitle off",
                startAtSubtitle: 1,
                subtitlesSource: [],
                //audio visualizer
                audioVisualizerLinesColor: "#0099FF",
                audioVisualizerCircleColor: "#FFFFFF",
                //advertisement on pause window
                aopwTitle: "Advertisement",
                aopwSource: "",
                aopwWidth: 400,
                aopwHeight: 240,
                aopwBorderSize: 6,
                aopwTitleColor: "#FFFFFF",
                //playback rate / speed
                showPlaybackRateButton: "no",
                defaultPlaybackRate: "1", //0.25, 0.5, 1, 1.25, 1.5, 2
                //sticky on scroll
                stickyOnScroll: "no",
                stickyOnScrollShowOpener: "yes",
                stickyOnScrollWidth: "700",
                stickyOnScrollHeight: "394",
                //sticky display settings
                showOpener: "yes",
                showOpenerPlayPauseButton: "yes",
                verticalPosition: "bottom",
                horizontalPosition: "center",
                showPlayerByDefault: "yes",
                animatePlayer: "yes",
                openerAlignment: "right",
                mainBackgroundImagePath: "content/minimal_skin_dark/main-background.png",
                openerEqulizerOffsetTop: -1,
                openerEqulizerOffsetLeft: 3,
                offsetX: 0,
                offsetY: 0,
                //embed window
                showEmbedWindowByDefault: "no",
                embedWindowCloseButtonMargins: 15,
                borderColor: "#333333",
                mainLabelsColor: "#FFFFFF",
                secondaryLabelsColor: "#a1a1a1",
                shareAndEmbedTextColor: "#5a5a5a",
                inputBackgroundColor: "#000000",
                inputColor: "#FFFFFF",
                //a to b loop
                useAToB: "no",
                atbTimeBackgroundColor: "transparent",
                atbTimeTextColorNormal: "#FFFFFF",
                atbTimeTextColorSelected: "#FF0000",
                atbButtonTextNormalColor: "#888888",
                atbButtonTextSelectedColor: "#FFFFFF",
                atbButtonBackgroundNormalColor: "#FFFFFF",
                atbButtonBackgroundSelectedColor: "#000000",
                //thumbnails preview
                thumbnailsPreview: "",
                thumbnailsPreviewWidth: 196,
                thumbnailsPreviewHeight: 110,
                thumbnailsPreviewBackgroundColor: "#000000",
                thumbnailsPreviewBorderColor: "#666",
                thumbnailsPreviewLabelBackgroundColor: "#666",
                thumbnailsPreviewLabelFontColor: "#FFF",
                // context menu
                contextMenuType: 'normal',
                showScriptDeveloper: "no",
                contextMenuBackgroundColor: "#1f1f1f",
                contextMenuBorderColor: "#1f1f1f",
                contextMenuSpacerColor: "#333",
                contextMenuItemNormalColor: "#888888",
                contextMenuItemSelectedColor: "#FFFFFF",
                contextMenuItemDisabledColor: "#444"
            });



        }
    },
};
</script>

<style lang="scss">
.wecodefy-yt-player-wrapper {
    height: 100%;
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;

    #myDivHolder {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;


        #myDiv {
            width: 100%;
            height: 100%;
            position: relative;
            display: flex;
            justify-content: center;
        }
    }


    /* Share window, uncomment to remove button from the share window */
    .fwdevp-facebook-share-button {
        /*	display: none !important;*/
    }

    .fwdevp-twitter-share-button {
        /*display: none !important;*/
    }

    .fwdevp-likedin-share-button {
        /*display: none !important;*/
    }

    .fwdevp-buffer-share-button {
        /*display: none !important;*/
    }

    .fwdevp-digg-share-button {
        /*display: none !important;*/
    }

    .fwdevp-reddit-share-button {
        /*	display: none !important;*/
    }

    .fwdevp-thumbrl-share-button {
        /*display: none !important;*/
    }


    /* Vector fonts buttons */
    .EVPMainButtonsNormalState {
        transform: rotate(0.3deg);
        overflow: visible !important;
        font-size: 20px !important;
        color: #999 !important;
    }

    .EVPMainButtonsSelectedState {
        transform: rotate(0.3deg);
        overflow: visible !important;
        font-size: 20px !important;
        color: #FFF !important;
    }

    .fwdevp .fwdicon {
        font-family: 'fwdicon';
    }

    .fwdevp .fwdicon:before {
        position: relative;
    }

    .fwdevp .fwdicon-vr:before {
        font-size: 25px;
        top: -1px;
    }

    .fwdevp .fwdicon-pause:before {
        font-size: 19px;
        top: -1px;
    }

    .fwdevp .fwdicon-download:before {
        top: -1px;
    }

    .fwdevp .fwdicon-embed {
        font-size: 21px;
    }

    .fwdevp .fwdicon-sound-off {
        font-size: 22px;
    }

    .fwdevp .fwdicon-sound {
        font-size: 24px;
    }

    .fwdevp .fwdicon-sound-off:before,
    .fwdevp .fwdicon-sound:before {
        top: 1px;
    }

    .fwdevp .fwdicon-fullscreen,
    .fwdevp .fwdicon-normalscreen {
        font-size: 19px;
    }


    .EVPLargePlayButtonNormalState {
        position: absolute;
        font-size: 30px;
        width: 86px;
        height: 59px;
        cursor: pointer;
        background-color: #1f1f1f;
        color: #6a6a6a;
    }

    .EVPLargePlayButtonNormalState .table-cell-fwdevp-button {
        padding: 2px 0 0;
    }

    .EVPLargePlayButtonSelectedState {
        position: absolute;
        font-size: 30px;
        width: 80px;
        height: 80px;
        cursor: pointer;
        background-color: #1f1f1f;
        color: #FFF;
    }

    .EVPLargePlayButtonSelectedState .table-cell-fwdevp-button {
        padding: 2px 0 0;
    }

    .EVPCloseButtonNormalState {
        overflow: visible;
        position: absolute;
        font-size: 14px;
        width: 40px;
        height: 39px;
        cursor: pointer;
        background-color: #1f1f1f;
        color: #FFFFFF;
    }

    .EVPCloseButtonNormalState .fwdicon-close {
        position: relative;
        top: 2px;
    }

    .EVPCloseButtonSelectedState {
        overflow: visible;
        position: absolute;
        font-size: 14px;
        width: 40px;
        height: 39px;
        cursor: pointer;
        background-color: #1f1f1f;
        color: #FF0000;
    }

    .EVPCloseButtonSelectedState .fwdicon-close {
        position: relative;
        top: 2px;
    }

    .EVPSocialMediaButtonsNormalState {
        font-size: 18px !important;
        color: #999999 !important;
        font-weight: 100;
    }

    .EVPSocialMediaButtonsSelectedState {
        font-size: 18px !important;
        color: #FFFFFF !important;
    }

    .table-fwdevp-button {
        display: table;
        width: 100%;
        height: 100%;
        position: absolute;
    }

    .table-cell-fwdevp-button {
        display: table-cell;
        width: 100%;
        height: 100%;
        vertical-align: middle;
        text-align: center;
    }

    /* Autoplay text. */
    .fwdevp-autoplay-text {
        font: 500 12px Roboto, Arial !important;
        top: 30px !important;
        left: 30px !important;
        border-radius: 14px;
        line-height: 14px !important;
        padding: 6px 23px 6px 18px !important;
        background-color: rgba(0, 0, 0, 0.4);
        color: #FFFFFF;

        transition: background-color .3s ease-out, color .3s ease-out;
    }

    .fwdevp-autoplay-text:hover {
        color: #000;
        background-color: rgba(255, 255, 255, 1);
    }

    .fwdevp-autoplay-text:hover svg path {
        fill: #111;
    }

    .fwdevp-autoplay-text svg {
        transform: translate(6px, 2px);
    }

    .fwdevp-autoplay-text svg path {
        transition: all .3s ease-out;
        fill: #FFFFFF;
    }


    /* Subtitle. */
    .EVPSubtitle {
        font: 600 22px Roboto, Arial !important;
        text-align: center !important;
        color: #FFFFFF !important;
        text-shadow: 0px 0px 1px #000000 !important;
        line-height: 28px !important;
        margin: 0 20px 20px !important;
        padding: 0px !important;
    }

    .EVPSubtitle.phone {
        font-size: 16px !important;
        line-height: 20px !important;
        margin: 0 10px 10px !important;
    }

    .EVPSubtitle.large {
        font-size: 28px !important;
        line-height: 38px !important;
        margin: 0 20px 20px !important;
    }


    /* Tooltips. */
    .EVP-tooltip-text {
        font-family: Roboto, Arial !important;
        padding: 5px 8px 5px !important;
    }

    /*Thumbnail preview text. */
    .fwdevp-thubnails-preview-text {
        font-family: Roboto, Arial !important;
        padding: 5px 8px 4px !important;
    }


    /* Annotations */
    .fwdevp-annotation-normal {
        font-family: Roboto, Arial !important;
        font-size: 14px !important;
        font-weight: 300 !important;
        width: 294px !important;
        line-height: 16px !important;
        padding: 18px 22px 16px 25px !important;
        color: #FFFFFF !important;
        background-color: rgba(0, 0, 0, .4) !important;
    }

    .fwdevp-annotation-link-normal {
        font-family: Roboto, Arial !important;
        font-size: 13px !important;
        width: 320px !important;
        font-weight: 300 !important;
        width: 343px !important;
        line-height: 16px !important;
        padding: 18px 22px 16px 25px !important;
        background-color: rgba(0, 0, 0, .8);
        color: #FFFFFF;
    }

    .fwdevp-annotation-link-selected {
        font-family: Roboto, Arial !important;
        font-size: 13px !important;
        width: 320px !important;
        font-weight: 300 !important;
        width: 343px !important;
        line-height: 16px !important;
        padding: 18px 22px 16px 25px !important;
        background-color: #FFFFFF;
        color: #000000;
    }

    .fwdevp-annotation-js-normal {
        font-family: Roboto, Arial !important;
        font-size: 13px !important;
        width: 320px !important;
        font-weight: 300 !important;
        width: 343px !important;
        line-height: 16px !important;
        padding: 18px 22px 16px 25px !important;
        background-color: rgba(0, 0, 0, .4);
        color: #FFFFFF !important;
    }

    .fwdevp-annotation-js-selected {
        font-family: Roboto, Arial !important;
        font-size: 13px !important;
        width: 320px !important;
        font-weight: 300 !important;
        width: 343px !important;
        line-height: 16px !important;
        padding: 18px 22px 16px 25px !important;
        background-color: #FFFFFF;
        color: #000000 !important;
    }

    .fwdevp-annotation-play-normal {
        font-family: Arial !important;
        text-align: center !important;
        width: 160px !important;
        padding: 10px !important;
        padding-top: 6px !important;
        padding-bottom: 6px !important;
        line-height: 20px !important;
        border-style: solid !important;
        border-width: 1px !important;
        border-color: #999999 !important;
        border-radius: 4px !important;
        box-shadow: 1px 1px 1px #999999 !important;
        background: #FFFFFF;
        color: #000000;
    }

    .fwdevp-annotation-play-selected {
        font-family: Arial !important;
        text-align: center !important;
        width: 160px !important;
        padding: 10px !important;
        padding-top: 6px !important;
        padding-bottom: 6px !important;
        line-height: 20px !important;
        border-style: solid !important;
        border-width: 1px !important;
        border-color: #FFFFFF !important;
        border-radius: 4px !important;
        box-shadow: 1px 1px 1px #999999 !important;
        background: #000000;
        color: #FFFFFF;
    }


    /* Logged in window dark. */
    .fwdevp-loggedin-message-dark {
        font: 400 14px Arial !important;
        color: #AAAAAA !important;
    }

    .fwdevp-loggedin-message-dark a {
        background-image: linear-gradient(#FFF calc(100% - 1px), #FFF 1px);
        background-size: 0% 2px;
        color: #CCC;
    }

    .fwdevp-loggedin-message-dark a:hover {
        background-size: 100% 2px;
        color: #FFF;
    }

    /* Logged in window white. */
    .fwdevp-loggedin-message-white {
        font: 400 14px Roboto, Arial !important;
        color: #6a6a6a !important;
    }

    .fwdevp-loggedin-message-white a {
        background-size: 100% 2px;
        color: #0099FF;
    }

    .fwdevp-display-none:before {
        display: none !important;
    }

    /* Controller. */
    .fwdevp-time,
    .fwdevp-qaulity-button {
        font: 400 12px Roboto, Arial !important;
    }

    /* Advertising. */
    .fwdevp-skip,
    .fwdevp-ads {
        font-family: Roboto, Arial !important;
    }

    /* Password window. */
    .fwdevp-password-title,
    .fwdevp-password-label,
    .fwdevp-password-input {
        font-family: Roboto, Arial !important;
    }

    .fwdevp-embed-button {
        display: none !important;
    }

}
</style>